// Module
var code = `<div
  class="external-item-container {{externalType}} external-{{externalId}} style-{{style}}"
>
  <ul class="external-bullets trim-linebreaks">
    {{#bullets}}
    <li><p>{{.*}}</p></li>
    {{/bullets}}
  </ul>

  <div class="code-sample-header">
    <div class="external-title"><p>{{title}}</p></div>
    <div class="external-subtitle check-for-empty"><p>{{subtitle}}</p></div>
  </div>
  <div
    class="external-content-container external-content-{{externalType}}"
  ></div>

  <div class="external-footer">{{footer}}</div>
</div>
`;
// Exports
module.exports = code;